export default "__VITE_ASSET__$qLAcyK___"